import * as yup from 'yup';
import Set from './CommonPasswords';

export function createYupSchema(schema: any, config: any) {
  const { name, validationType, requiredErrorMsg } = config;
  if (!(yup as any)[validationType]) {
    return schema;
  }
  let validator = (yup as any)[validationType]();
  requiredErrorMsg.forEach((validation: any) => {
    const { params, type, field, maxLength } = validation;
    if (!validator[type]) {
      return;
    }
    const postalCodeRegExp = /^[0-9a-zA-Z]+$/;
    const cityRegExp = /^[a-zA-Z]+$/;
    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
    const nameRegExp = /^[A-Za-z0-9-@.\/#&+\w\s ]*$/;
    const passwordRegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[[\]@_!#$%^&*()<>?/\|}{~:])[a-zA-Z\d\w\W]{8,20}$/g;
    switch (field) {
      case 'Phone':
        validator = validator[type](phoneRegExp, params)
          .min(
            maxLength,
            `Total number of digits of phone number should be ${maxLength}`
          )
          .max(
            maxLength,
            `Total number of digits of phone number should be ${maxLength}`
          );
        break;
      case 'Password':
        validator = validator[type](passwordRegEx, params);
        break;
      case 'PasswordOneOf':
        validator = validator[type](
          [yup.ref('OtherInfo_NewPassword'), null],
          params
        );
        break;
      case 'PasswordNotOneOf':
        validator = validator[type](Set, params);
        break;
      case 'Postal':
        validator = validator[type](postalCodeRegExp, params).max(
          maxLength,
          `Text entered exceeds max length of ${maxLength}`
        );
        break;
      case 'Name':
        validator = validator[type](nameRegExp, params).max(
          maxLength,
          `Text entered exceeds max length of ${maxLength}`
        );
        break;
      case 'Address':
        validator = validator[type](maxLength, params);
        break;
      case 'City':
        validator = validator[type](cityRegExp, params).max(
          maxLength,
          `Text entered exceeds max length of ${maxLength}`
        );
        break;
      case 'DriverLicense':
        validator = validator[type](maxLength, params);
        break;
      case 'MilitaryCO':
        validator = validator[type](maxLength, params);
        break;
      case 'MilitaryID':
        validator = validator[type](maxLength, params);
        break;
      default:
        validator = validator[type](params);
    }
  });
  schema[name] = validator;
  return schema;
}
